import React from 'react';
import { useTranslation } from 'react-i18next';

import { COLOURS } from '@tq/ui-components/dist/pp2/theme';
import { Container, Flex, FormControl, FormLabel, Grid } from '@tq/ui-components';

import { ManageTeamInviteUser, ManageTeamUsers, PageHeading, SearchText } from 'components';
import { manageUsersSearchState } from 'store';
import { useGetAdminUsersRecords } from './hooks';
import { TQAdminProvider } from '../../components/TQAdminProvider';

export const ManageAdminUsers: React.FC = () => {
  const { t } = useTranslation('manage_tq');
  const { userData, totalCount } = useGetAdminUsersRecords();

  return (
    <TQAdminProvider>
      <Container px={{ base: 0, lg: 4, xl: 0 }}>
        <Grid gridGap={2} mb='3rem'>
          <PageHeading heading={t('manage_tq_admin', 'TQ Admin - Manage users')} />
          <ManageTeamInviteUser
            title={t('invite_admin_users', 'Invite Admin user')}
            buttonText={t('button_text_send', 'Send Invite')}
            pageType='ManageTQAdmin'
          />
          <Flex
            id='table-filter'
            width={{ base: '100%', lg: '75%' }}
            mb={{ base: '1.25rem', lg: '2rem' }}
            p={{ base: '1.25rem', lg: 0 }}
            flexDirection={{ base: 'column', lg: 'row' }}
            bg={{ base: COLOURS.gray[200], lg: COLOURS.white }}
          >
            <FormControl flex='1 1 100%'>
              <FormLabel display={{ base: 'none', lg: 'block' }}>
                {t('search_label', 'Search')}:
              </FormLabel>
              <SearchText
                searchState={manageUsersSearchState}
                placeholderText={t('search_placeholder', 'Search user')}
                recordCount={userData.length}
                totalCount={totalCount}
              />
            </FormControl>
          </Flex>
          <ManageTeamUsers applicationUsers={userData} isAdmin={true} />
        </Grid>
      </Container>
    </TQAdminProvider>
  );
};
